
import React, { useState, useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/parallax';
import { Navigation, Pagination, Autoplay, EffectFade, Parallax } from 'swiper/modules';

import '../App.css';

// Imágenes del carrusel
import imagen01 from '../img/carrusel95.jpg';
import imagen02 from '../img/carrusel93.jpg';
import imagen03 from '../img/carrusel92.jpg';
import imagen04 from '../img/carrusel89.jpg';
import imagen05 from '../img/carrusel91.jpeg';
import imagen06 from '../img/carrusel90.jpg';
import imagen07 from '../img/Feria2025-01.jpeg';
import imagen08 from '../img/Feria2025-02.jpeg';
import imagen09 from '../img/Feria2025-03.jpeg';
import imagen10 from '../img/Feria2025-04.jpeg';
import imagen11 from '../img/Licenciatura 8vo básico 2025.JPG';
import imagen12 from '../img/Kinder 2025.jpg';

// 🔹 Aviso flotante
import avisoMedia from '../img/Inicio-Clases-2026.png';

// 🔹 LINK externo (si está vacío abrirá la imagen automáticamente)
const AVISO_LINK = '';

const CarouselComponent = () => {

  const [isFloatingMessageVisible, setIsFloatingMessageVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const swiperRef = useRef(null);

  // Posición de arrastre
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const dragRef = useRef({ isDragging: false, startX: 0, startY: 0 });

  // Barra de progreso
  useEffect(() => {
    const interval = setInterval(() => {
      if (swiperRef.current) {
        const swiper = swiperRef.current.swiper;
        const total = swiper.slides.length;
        const current = swiper.realIndex;
        setProgress(((current + swiper.progress) / total) * 100);
      }
    }, 50);
    return () => clearInterval(interval);
  }, []);

  const images = [
    imagen12, imagen11, imagen10, imagen09, imagen08, imagen07,
    imagen06, imagen05, imagen04, imagen03, imagen02, imagen01
  ];

  // ----- DRAG -----
  const handleMouseDown = (e) => {
    dragRef.current.isDragging = true;
    dragRef.current.startX = e.clientX - position.x;
    dragRef.current.startY = e.clientY - position.y;
  };

  const handleMouseMove = (e) => {
    if (!dragRef.current.isDragging) return;
    setPosition({
      x: e.clientX - dragRef.current.startX,
      y: e.clientY - dragRef.current.startY,
    });
  };

  const handleMouseUp = () => {
    dragRef.current.isDragging = false;
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  // 🔥 ABRIR LINK O IMAGEN AUTOMÁTICAMENTE
  const handleOpen = () => {
    const urlToOpen =
      AVISO_LINK && AVISO_LINK.trim() !== ''
        ? AVISO_LINK
        : avisoMedia;

    window.open(urlToOpen, '_blank');
  };

  // 🔹 Render imagen o video
  const renderMedia = () => {
    const extension = avisoMedia.split('.').pop().toLowerCase();
    const isVideo = ['mp4', 'mov', 'webm'].includes(extension);

    if (isVideo) {
      return (
        <video
          src={avisoMedia}
          autoPlay
          loop
          muted
          playsInline
          onClick={handleOpen}
          style={mediaStyle}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        />
      );
    }

    return (
      <img
        src={avisoMedia}
        alt="Aviso Inicio de Clases"
        onClick={handleOpen}
        style={mediaStyle}
        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
      />
    );
  };

  return (
    <div style={{ position: 'relative', width: '100%', maxWidth: '1200px', margin: '0 auto' }}>

      {/* Barra de progreso */}
      <div style={progressBarWrapper}>
        <div style={{ ...progressBar, width: `${progress}%` }} />
      </div>

      {/* Carrusel */}
      <Swiper
        ref={swiperRef}
        modules={[Navigation, Pagination, Autoplay, EffectFade, Parallax]}
        effect="fade"
        loop
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        navigation
        pagination={{ clickable: true }}
        speed={1000}
        parallax
        style={{ borderRadius: '15px', overflow: 'hidden' }}
      >
        {images.map((img, index) => (
          <SwiperSlide key={index}>
            <div style={slideWrapperStyle}>
              <img src={img} alt={`Imagen ${index + 1}`} style={slideImageStyle} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Aviso flotante */}
      {isFloatingMessageVisible && (
        <div
          style={{
            ...floatingMessageStyle,
            top: `calc(50% + ${position.y}px)`,
            left: `calc(50% + ${position.x}px)`,
            cursor: dragRef.current.isDragging ? 'grabbing' : 'grab',
          }}
          onMouseDown={handleMouseDown}
        >
          <div style={floatingContentWrapperStyle}>
            {renderMedia()}

            <button
              onClick={() => setIsFloatingMessageVisible(false)}
              style={closeButtonStyle}
            >
              ✕
            </button>
          </div>
        </div>
      )}

      <style>
        {`
          @keyframes slideDownFade {
            0% { opacity: 0; transform: translateY(-50px); }
            100% { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
};

// ----- ESTILOS -----

const mediaStyle = {
  width: '65%',
  maxWidth: '400px',
  height: 'auto',
  borderRadius: '12px',
  boxShadow: '0 6px 18px rgba(0,0,0,0.3)',
  transition: 'transform 0.3s',
  animation: 'slideDownFade 0.6s ease-out',
  cursor: 'pointer',
};

const slideWrapperStyle = {
  width: '80%',
  maxWidth: '800px',
  height: '400px',
  margin: '0 auto',
  borderRadius: '10px',
  overflow: 'hidden',
  boxShadow: '0 8px 16px rgba(0,0,0,0.3)',
};

const slideImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

const progressBarWrapper = {
  position: 'absolute',
  top: '10px',
  left: '5%',
  width: '90%',
  height: '5px',
  backgroundColor: 'rgba(255,255,255,0.3)',
  borderRadius: '5px',
  zIndex: 15,
};

const progressBar = {
  height: '100%',
  backgroundColor: '#ff4d4f',
  borderRadius: '5px',
};

const floatingMessageStyle = {
  position: 'fixed',
  backgroundColor: 'rgba(255,255,255,0.6)',
  backdropFilter: 'blur(10px)',
  padding: '15px',
  borderRadius: '20px',
  boxShadow: '0 12px 30px rgba(0,0,0,0.3)',
  zIndex: 9999,
  transform: 'translate(-50%, -50%)',
  userSelect: 'none',
};

const floatingContentWrapperStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const closeButtonStyle = {
  marginTop: '12px',
  padding: '8px 16px',
  backgroundColor: '#ff4d4f',
  color: '#fff',
  border: 'none',
  borderRadius: '12px',
  cursor: 'pointer',
  fontSize: '16px',
  fontWeight: 'bold',
};

export default CarouselComponent;